export { QuestionsGameCoreModule } from './questions-game-core.module';
export { QuestionsGameSelectorComponent } from './questions-game-selector/questions-game-selector.component';
export { QuestionsGameCoreService } from './questions-game-core.service';
export { IQuestionGame } from './questions-game.interface';
